import { getToastStore } from '@utils/ToastStore';
import { t } from 'i18next';
import Cookies from 'js-cookie';

const ctxToast = getToastStore();
export const base64ToFile = (base64: string, filename: string) => {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] ?? 'image/jpeg';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
};

export const successToast = (ctxToast: any, message: string) => {
    if (ctxToast) {
        ctxToast.setToastMsg(message);  
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(false);
    }
}

export const errorToast = (ctxToast: any, message: string) => {
    if (ctxToast) {
        ctxToast.setToastMsg(message);
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(true);
    }   
}

export const isValidUrl = (url: string): boolean => {
  if (!url || typeof url !== "string") return false;
  try {
    const normalizedUrl = url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
    const parsed = new URL(normalizedUrl);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export const getUserFromCookie = () => {
  const raw = Cookies.get('hst-user-data');
  if (!raw) return null;

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
};

export const handleDefaultImgClick = (
  base64Image: string, index: number, 
  setter: Function, setterPreview: Function,
  formData: FormData 
) => {
    try {
      const file = base64ToFile(base64Image, `default-image-${index}.jpg`);
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        if (ctxToast) {
          ctxToast.setToastMsg(t("error.too_large"));
          ctxToast.setSeeToast(true);
          ctxToast.setErrorToast(true);
        }
        return;
      }

      setter(file);

      const previewUrl = URL.createObjectURL(file);
      setterPreview(previewUrl);

      formData.append('img', file);
      //return formData
    } catch (error) {
      console.error('Errore conversione immagine:', error);
      if (ctxToast) {
        ctxToast.setToastMsg(t("error.invalid_image_format"));
        ctxToast.setSeeToast(true);
        ctxToast.setErrorToast(true);
      }
    }
  }